import { render, staticRenderFns } from "./ThreadList.vue?vue&type=template&id=2c17afd0&scoped=true"
import script from "./ThreadList.vue?vue&type=script&lang=js"
export * from "./ThreadList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c17afd0",
  null
  
)

export default component.exports